let Init = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.select();
        this.select2();
        // this.datepicker(); TODO HAS ERROR
        this.tooltip();
        this.clickable();
        // this.toastr(); TODO HAS ERROR
        this.customUpload();
    },

    select() {
        $(document).on('mousedown', 'select[readonly]', function (e) {
            e.preventDefault();
            this.blur();
            window.focus();
        });
    },

    select2() {
        $('.select2').select2({
            templateSelection: function(item) {
                /** @type {jQuery} HTMLOptionElement */
                let $option = $(item.element);
                let $optGroup = $option.parent();
                return $option.data('name');
            },
            minimumResultsForSearch: Infinity,
            width: '100%',
            tags: true,
            createTag: function (item) {},
        });

        $('.one-level-select2').select2({
            templateSelection: function(item) {
                /** @type {jQuery} HTMLOptionElement */
                let $option = $(item.element);
                let $optGroup = $option.parent();
                return $option.data('name');
            },
            minimumResultsForSearch: Infinity,
            width: '100%'
        });


        // on first focus (bubbles up to document), open the menu
        $(document).on('focus', '.select2-selection.select2-selection--single', function (e) {
            $(this).closest(".select2-container").siblings('select:enabled').select2('open');
        });

        // steal focus during close - only capture once and stop propogation
        $('select.select2').on('select2:closing', function (e) {
            $(e.target).data("select2").$selection.one('focus focusin', function (e) {
                e.stopPropagation();
            });
        });

        function formatState(state) {
            if (!state.id) {
                return state.text;
            }

            let $state = $(
                '<span><img src="' + state.element.attributes.img.value + '" class="dropdown-flag" /> ' + state.text + '</span>'
            );
            return $state;
        };

        $('.countries-select2').select2({
            templateResult: formatState
        });
    },

    // datepicker() {
    //     $('.datepicker').datepicker({
    //         format: 'mm/dd/yyyy',
    //         orientation: 'bottom',
    //         endDate: '+0d'
    //     });
    //
    //     $('.monthyearpicker').datepicker({
    //         format: 'mm/yyyy',
    //         orientation: 'bottom',
    //         viewMode: "months",
    //         minViewMode: "months",
    //         endDate: '+0d',
    //         autoclose: true,
    //     });
    // },

    tooltip() {
        $('[data-toggle="tooltip"]').tooltip()
    },

    clickable() {
        $(document).on('click', '[data-href]', function () {
            const href = $(this).data('href');

            if (href.length) {
                window.open(href, '_blank');
                // window.location.assign(href);
            }
        });
    },

    // toastr: function () {
    //     toastr.options = {
    //         "debug": false,
    //         "newestOnTop": false,
    //         "positionClass": "toast-top-right",
    //         "closeButton": true,
    //         "toastClass": "animated fadeInDown",
    //     };
    // },

    customUpload() {
        $('.custom-file-input').on('change', function () {
            let fileName = $(this).val().split("\\").pop();
            $(this).siblings('.custom-file-label').addClass('selected').html(fileName);
        });
    },
};


$().ready(() => {
    window.Init = Init;
    window.Init.init();
});
